import { Component, OnInit, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { AutocompleteModule, ButtonModule, DialogConfig, DialogRef } from '@sag-ui';
import { select, Store } from '@ngxs/store';
import { UserState } from '../../../../user-management/state/user-management.state';
import { IUser, Roles } from '@cod-monorepo/interfaces';
import { LoadAssignableUsers } from '../../../../user-management/state/user-management.action';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
    selector: 'app-reassign-cod-dialog',
    standalone: true,
    imports: [CommonModule, ButtonModule, SharedModule, AutocompleteModule, FormsModule, ReactiveFormsModule],
    templateUrl: './reassign-cod.component.html'
})
export class ReassignCodDialogComponent implements OnInit {
    public assignableUsers: Signal<IUser[]> = select(UserState.assignableUsers);
    public assignableUsersLoading: Signal<boolean> = select(UserState.assignableUsersLoading);
    public formControl = new FormControl<string | null>(null, Validators.required);

    constructor(
        public config: DialogConfig<{ role: Roles }>,
        public dialogRef: DialogRef<string>,
        private store: Store
    ) {}

    ngOnInit(): void {
        this.loadUsers();
    }

    public onClose(result?: string): void {
        if (result) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.dialogRef.close(this.formControl.value!);
            return;
        }

        this.dialogRef.close();
    }

    public get invalid(): boolean {
        return this.formControl.invalid;
    }

    private loadUsers(): void {
        if (this.config.data) {
            this.store.dispatch(new LoadAssignableUsers(this.config.data?.role));
        }
    }
}
